export default {
  examQuestionType: {
    id: '',
    code: '',
    nameLocal: '',
    nameEng: '',
  },
  examQuestionTypes: [],
  processing: false,
  error: null,
  success: null,
}



